import { render, staticRenderFns } from "./OfflineDetail.vue?vue&type=template&id=ad53240c"
import script from "./OfflineDetail.vue?vue&type=script&lang=js"
export * from "./OfflineDetail.vue?vue&type=script&lang=js"
import style0 from "./OfflineDetail.vue?vue&type=style&index=0&id=ad53240c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports